<div *ngIf="errorText" class="mt-12">
  <mat-error>{{errorText}}</mat-error>
</div>

<section class="tracking-info p-32">
  <div class="mt-12" *ngIf="payload" class="relative">
    <dp-container-details [container]="payload"></dp-container-details>
    <dp-svg *ngIf="!showReportError" class="reportIcon" tooltip="Report error" [src]="udsIconMap.report" w="20"
      (click)="reportError()"></dp-svg>
  </div>

  <div *ngIf="!showReportError" @slideInLeft>
    <mat-tab-group style="overflow-y: auto;" (selectedTabChange)="selectedTabChange($event)">

      <!-- Tracking Tab -->
      <mat-tab [label]="tabs[0] | translate">
        <section class="tab-content">

          <div *ngIf="transportJourneys">
            <ng-container *ngIf="Utility.isRoadShipment(payload?.shippingMode); else trackingInfo">
              <div class="truck-summary" *ngIf="transportJourneys?.roadTransport; let roadTransport">
                <h3>{{'common.tracking_details_txt' | translate}}</h3>
                <div class="row">
                  <dp-address [address]="roadTransport?.originAddressComponents" [addressType]="'Origin'"></dp-address>
                  <dp-address [address]="roadTransport?.destinationAddressComponents" [addressType]="'Destination'"></dp-address>
                </div>
                <div class="row mt-8">
                  <div class="halfWidth">
                    <span class="propertyCaption">{{roadTransport?.ata ? 'ATD': 'ETD'}} </span>
                    <span class="value">{{roadTransport?.atd ? roadTransport?.atd : roadTransport?.etd}}</span>
                  </div>
                  <div class="halfWidth">
                    <span class="propertyCaption">{{roadTransport?.ata ? 'ATA': 'ETA'}} </span>
                    <span class="value">{{roadTransport?.ata ? roadTransport?.ata : roadTransport?.eta}}</span>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-template #trackingInfo>
              <h3>{{'common.tracking_details_txt' | translate}}</h3>
              <dp-tracking-details [isManualIntermodalLinkage]="payload.isManualIntermodalLinkage" [transportJourneys]="transportJourneys" [shipment]="payload"></dp-tracking-details>
            </ng-template>
          </div>

          <ng-container *ngIf="transportJourneys?.shipToPort?.segmentData; let segmentData">
            <dp-shipment-segment [isIntermodalRoad]="true" [driverPhone]="transportJourneys?.shipToPort?.driverPhone" [segmentData]="segmentData" [context]='getPredictedEtaContext()'
              heading="{{'common.shipping_segments_txt' | translate}} - {{'shipments.ocean_shipments.first_mile_txt' | translate}}"></dp-shipment-segment>
          </ng-container>
          <ng-container *ngIf="transportJourneys?.portToPort?.segmentData; let segmentData">
            <dp-shipment-segment [isManualIntermodalLinkage]="payload.isManualIntermodalLinkage" [segmentData]="segmentData" [context]='getPredictedEtaContext()'
              heading="{{'common.shipping_segments_txt' | translate}}"></dp-shipment-segment>
          </ng-container>
          <ng-container *ngIf="transportJourneys?.shipToDestination?.segmentData; let segmentData">
            <dp-shipment-segment [isIntermodalRoad]="true" [driverPhone]="transportJourneys?.shipToDestination?.driverPhone" [segmentData]="segmentData" [context]='getPredictedEtaContext()'
              heading="{{'common.shipping_segments_txt' | translate}} - {{'shipments.ocean_shipments.last_mile_txt' | translate}}"></dp-shipment-segment>
          </ng-container>

          <ng-container *ngIf="shipmentMap">
            <h3>{{'common.tracking_events_txt' | translate}}</h3>
            <dp-shipment-map [isManualIntermodalLinkage]="payload.isManualIntermodalLinkage" [shipmentDetail]="shipmentMap" [maxZoom]="12"></dp-shipment-map>
          </ng-container>
          <div class="mt-12 pl-12" *ngIf="payload.trackingUpdatedAt">
            <label class="text-muted">{{'common.last_updated_txt' | translate}}: </label>
            <span class="value">{{ payload.trackingUpdatedAt | dateAgo }}</span>
          </div>
          <ng-container *ngIf="['FTL', 'LTL'].includes(payload?.shippingMode); else trackingStepsInfo">
            <div *ngIf="transportJourneys?.roadTransport?.statusSteps?.steps; let steps" class="mt-12 pl-12">
              <dp-tracking-step [steps]="steps"></dp-tracking-step>
            </div>
          </ng-container>
          <ng-template #trackingStepsInfo>
            <div *ngIf="transportJourneys?.portToPort?.statusSteps?.steps; let steps" class="mt-12 pl-12">
              <dp-tracking-step [steps]="steps" [context]='getPredictedEtaContext()'></dp-tracking-step>
            </div>
          </ng-template>
        </section>
      </mat-tab>

      <!-- Documents Tab -->
      <mat-tab *ngIf="showDocumentsInSharedLinks">
        <ng-template mat-tab-label>
          {{'common.documents_txt' | translate}}
          <ng-container *ngIf="payload?.documents?.length !== 0">
            <div [ngClass]="{'active': selectedTabIndex === 1, 'miniFab' : payload?.documents?.length}">
              {{ payload?.documents?.length }}</div>
          </ng-container>
        </ng-template>


        <section class="tab-content">

          <!-- No document cases -->
          <div *ngIf="payload?.documents?.length == 0" fxLayout="column" fxLayoutAlign="center center">
            <h2 class="text-muted">{{'common.no_doc_available_txt' | translate}}!</h2>
            <!-- <img src="assets/images/svg/no-result-found.svg" /> -->
          </div>

          <ng-container *ngIf="payload?.documents?.length > 0">
            <dp-documents-upload-card-public *ngFor="let document of payload.documents" [document]="document"
              [entityType]="EntityType?.TRACKING_SHIPMENT" [tokenId]="tokenId">
            </dp-documents-upload-card-public>
          </ng-container>

        </section>
      </mat-tab>

      <mat-tab *ngIf="showException && !isEmpty(payload.exceptions)">
        <ng-template mat-tab-label>
          {{'common.exceptions_txt' | translate}}
          <div *ngIf="exceptionCount" class="miniFab" [ngClass]="{'active': selectedTabIndex === 2}">
            {{ exceptionCount }}</div>
        </ng-template>
        <section class="tab-content mt-8">
          <dp-os-exception [shipmentDetail]="payload" [steps]="payload?.exceptions?.steps"></dp-os-exception>
        </section>
      </mat-tab>

    </mat-tab-group>
  </div>

  <dp-report-error *ngIf="showReportError" [isEmail]="true" @slideInRight (goBack)="close()" (close)="close()" [data]="payload"
    [commentOnly]="true">
  </dp-report-error>
</section>